export interface UploadComprobanteResult {
  url: string;
  nombre: string;
  tamano: number;
}

export async function uploadComprobante(
  file: File,
  tallerId: string,
  inscripcionRef: string
): Promise<UploadComprobanteResult> {
  const formData = new FormData();
  formData.append('comprobante', file);
  formData.append('tallerId', tallerId);
  formData.append('inscripcionRef', inscripcionRef);

  const endpoint =
    process.env.REACT_APP_UPLOAD_COMPROBANTE_URL ||
    'https://ampirivieranayarit.com/modulob/backend/upload-comprobante.php';

  const res = await fetch(endpoint, { method: 'POST', body: formData });

  if (!res.ok) {
    const msg = await safeError(res);
    throw new Error(msg || `Upload respondió ${res.status}`);
  }

  const json = await res.json();
  if (!json?.url) {
    throw new Error(json?.error || 'Respuesta sin URL');
  }
  return json as UploadComprobanteResult;
}

async function safeError(res: Response): Promise<string | null> {
  try {
    const j = await res.json();
    return j?.error || null;
  } catch {
    return null;
  }
}
